export enum RecordingStatus {
    RECORDING = 'RECORDING',
    PROCESSING = 'PROCESSING',
    AVAILABLE = 'AVAILABLE',
    DELETED = 'DELETED',
    EXTERNAL = 'EXTERNAL'
}

export enum Permission {
    PUBLIC = 'PUBLIC',
    ROSTER = 'ROSTER',
    ADMINS = 'ADMINS'
}

export enum ConfigIngestModes {
    EXCLUDE = 'EXCLUDE',
    TRACK = 'TRACK',
    COPY = 'COPY',
    MOVE = 'MOVE'
}

export type Artifact = {
    recordingId: string;
    contents: string;
    timeToLive: number;
    url: string;
    type: string;
};

export type Artifacts = {
    active_speaker?: Artifact;
    closed_caption?: Artifact;
    timeline?: Artifact;
    audio_only?: Artifact;
    gallery_view?: Artifact;
    shared_screen?: Artifact;
    shared_screen_with_gallery_view?: Artifact;
    shared_screen_with_speaker_view?: Artifact;
    'shared_screen_with_speaker_view(CC)'?: Artifact;
};

export interface RecordingInformation {
    schoolId: string;
    classId: string;
    sessionId: string;
    recordingId: string;
    name: string;
    status: RecordingStatus;
    permission?: Permission;
    when: string;
    duration?: number;
    artifacts?: Artifacts;
    size?: number;
    totalViews: number;
    lastViewed?: string;
}
